import { allTrue } from '../../utils/fn'
import { info } from '../../application/console'
import { queryString as qs } from '../../utils/window'
import { getIsNativeApp, getIsMobile, path } from '../../utils/ua'
import { getSite, postTemplate, getPageLocale, getPostId } from '../../application/pageDataObject'
import { scriptLoadingStart, scriptLoadingEnd } from '../actions/browsiActions'
import { referringDomain } from '../../utils/dom'
import { getInfluencerId } from '../../utils/pageContext'
import { trackUserIdentifier } from '../../../components/googleAnalyticaSessionTracker/useridentifierTracker'

const experimentId = parseInt(trackUserIdentifier())
const { isEmbedded } = path
const FEATURE_FLAGS = {
  forceBrowsi: qs.forceBrowsi,
  debug: qs.debugBrowsi,
}
const BROWSI_ALLOWED_DOMAINS = ['90min', '12up', 'dbltap', 'floor8', 'german_site', 'theduel']
const SHINEZ_POSTS = [
  6242836,
  6296514,
  6296515,
  6296517,
  6296519,
  6296521,
  6296525,
  6296532,
  6296536,
  6296537,
  6296544,
  6296549,
  6296551,
  6296562,
  6296565,
  6296566,
  6296568,
  6296572,
  6296574,
  6296576,
  6296578,
  6296580,
  6296583,
  6296586,
  6296587,
  6296588,
  6296590,
  6296592,
  6296593,
  6296594,
]
const BROWSI_AFFID_BY_DOMAIN = {
  '12up': '12up',
  '90min': '90min',
  floor8: 'floor8',
  dbltap: 'dbltap',
  german_site: '90min',
  theduel: 'theduel',
}

const NINETY_MIN_MARKETPLACE_TRIVIA_GEO = [`"UK"`]
const FLOOR_EIGHT_MARKETPLACE_TRIVIA_GEO = [`"US"`, `"IL"`]

const SCRIPT = 'https://middycdn-a.akamaihd.net/bootstrap/bootstrap.js'

const BROWSI_ALLOWED_UTM_SOURCES = ['facebook']
const BROWSI_ALLOWED_REFERRALS = ['facebook.com']

const affiliateId = getInfluencerId() // eslint-disable-line camelcase

//yoni TODO - delete it by 1/5/18
// function hasAllowedReferral() {
//   const externalReferrer = referringDomain()
//   return BROWSI_ALLOWED_REFERRALS.some(externalReferrer.includes, externalReferrer)
// }

// function hasAffiliateId() {
//   return affiliateId !== true && !!affiliateId
// }

function getUtmSource() {
  return qs.utm_source || 'NO_UTM_SOURCE'
}

function hasAllowedUtmSource(utmSource = getUtmSource()) {
  return BROWSI_ALLOWED_UTM_SOURCES.some(utmSource.includes, utmSource)
}

function hasWhitelistQuerystring() {
  return hasAllowedUtmSource()
}

function debug() {
  if (FEATURE_FLAGS.debug) {
    info('[browsi]', ...arguments)
  }
}

export function isBrowsiEnabled() {
  const predicates = [
    getIsMobile(),
    BROWSI_ALLOWED_DOMAINS.includes(getSite()),
    !SHINEZ_POSTS.includes(getPostId()),
    // hasWhitelistQuerystring(),
  ]
  const shouldLoadBrowsi = FEATURE_FLAGS.forceBrowsi || allTrue(...predicates)
  debug('isBrowsiEnabled?', shouldLoadBrowsi, { predicates })
  return shouldLoadBrowsi
}

function beforeLoad() {
  debug('before script load')
  debug('browsi script src', SCRIPT)
  scriptLoadingStart()
}

function onload() {
  // eslint-disable-line no-shadow
  debug('on script load')
  scriptLoadingEnd()
}

function shouldLoadIn90minTriviaConfig() {
  return (
    postTemplate === 'article' &&
    window.location.search.includes('app=1') &&
    getSite() === '90min' &&
    getPageLocale() === 'en' &&
    !isEmbedded
  )
}

function shouldLoadInFloor8TriviaConfig() {
  return (
    postTemplate === 'article' &&
    experimentId > 0 &&
    experimentId < 41 &&
    getSite() === 'floor8' &&
    getPageLocale() === 'en' &&
    !isEmbedded &&
    FLOOR_EIGHT_MARKETPLACE_TRIVIA_GEO.includes(localStorage.getItem('NM_GEOLOCATION'))
  )
}

function shouldLoadInFotmobTrivia() {
  return (
    window.location.search.includes('utm_source=fotmob&utm_medium=api') &&
    !window.location.search.includes('noAds') &&
    getPageLocale() === 'en' &&
    isEmbedded
  )
}

function shouldLoadTriviaConfigOandO() {
  return shouldLoadIn90minTriviaConfig()
}

function shouldLoadMarketPlaceConfig() {
  return shouldLoadTriviaConfigOandO() || shouldLoadInFotmobTrivia()
}

function getBrowsiKey() {
  return shouldLoadMarketPlaceConfig() ? 'mmwidget' : BROWSI_AFFID_BY_DOMAIN[getSite()]
}
export const browsiScriptConfig = {
  name: 'browsi',
  src: SCRIPT,
  id: 'browsi-tag',
  'data-pubKey': 'minutemedia',
  'data-siteKey': getBrowsiKey(),
  beforeLoad,
  onload,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/browsiScriptConfig.js